import Axios from "axios";
import { getCryptoApiBaseUrl } from "@/config/runtime";

function normalizeCryptoError(error) {
  const responseData = error?.response?.data;
  const status = error?.response?.status;
  const method = error?.config?.method?.toUpperCase?.() || "REQUEST";
  const url = error?.config?.url || "";
  const message =
    responseData?.detail ||
    responseData?.message ||
    error?.message ||
    "Request failed";
  return {
    ...responseData,
    status,
    method,
    url,
    message,
  };
}

let cachedCryptoBase = "";
let cryptoClient = null;

function getCryptoHttp() {
  const baseURL = getCryptoApiBaseUrl();
  if (!baseURL) {
    const err = new Error(
      "Не задан VUE_APP_CRYPTO_API_URL (база крипто-сервиса)",
    );
    err.code = "CRYPTO_API_URL_MISSING";
    throw err;
  }
  if (cachedCryptoBase !== baseURL) {
    cachedCryptoBase = baseURL;
    cryptoClient = Axios.create({ baseURL });
    cryptoClient.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(normalizeCryptoError(error)),
    );
  }
  return cryptoClient;
}

/**
 * GET {VUE_APP_CRYPTO_API_URL}/api/v1/payments/tokens/?network__name=&symbol__name=
 * (отдельный хост, не основной VUE_APP_API_URL).
 */
export default {
  async listTokens(params = {}) {
    const client = getCryptoHttp();
    const response = await client.get("api/v1/payments/tokens/", { params });
    return response?.data ?? response;
  },
  async createPaymentRequest(payload) {
    const client = getCryptoHttp();
    const response = await client.post(
      "api/v1/payments/payment-requests/create/",
      payload,
    );
    return response?.data ?? response;
  },
  /** GET …/payment-orders/{uuid}/status/ — актуальное состояние заказа и active_payment. */
  async getPaymentOrderStatus(publicId) {
    const client = getCryptoHttp();
    const id = encodeURIComponent(String(publicId || "").trim());
    const response = await client.get(
      `api/v1/payments/payment-orders/${id}/status/`,
    );
    return response?.data ?? response;
  },
};
